<ng-container *ngIf="showOverlay">
  <div class="container">
    <div class="closeable-overlay">
      <div class="ack-text">{{text}}</div>
      <button mat-flat-button (click)="agree()" name="ack-button">Ok</button>
    </div>
  </div>
</ng-container>
